import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../src/images/logoDocLift.png";
import userIcon from "../../src/images/user.svg";
import { getDataFromLocalStorage } from "../util/localStorage";
import AI_PDF_CONST from "../util/PdfAiConst";
import { canAccessWorkspace } from "../util/accessControl";
import useAuth from "../hooks/useAuth";

const marketingLinks = [
  { label: "Services", href: "/home#what-doclift-does" },
  { label: "Industries", href: "/home#industries" },
  { label: "Trust", href: "/home#trust" },
];

const resourceLinks = [
  { label: "Pricing", href: "/pricing" },
  { label: "Contact", href: "/contact" },
];

const Header = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const useFullWidthHeader = location.pathname !== "/home2";

  useEffect(() => {
    setUserInfo(getDataFromLocalStorage("userInfo"));
    setMenuOpen(false);
  }, [location]);

  const logout = () => {
    localStorage.clear();
    setMenuOpen(false);
    navigate("/login");
  };

  return (
    <header className={`glass-header fixed top-0 z-50 w-full ${useFullWidthHeader ? "glass-header-full" : ""}`}>
      <div className="glass-header-shell mx-auto mt-3 flex min-h-[58px] max-w-[1180px] items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to={AI_PDF_CONST.ROUTE.HOME} className="glass-logo-link flex items-center">
          <img className="h-[30px] w-auto" src={logo} alt="DocLift" />
        </Link>

        <nav className="hidden items-center gap-7 lg:flex">
          {marketingLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="glass-nav-link text-sm font-semibold text-[#26384d]"
            >
              {link.label}
            </a>
          ))}
          {resourceLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="glass-nav-link text-sm font-semibold text-[#26384d]"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          {userInfo ? (
            <>
              <NavLink
                to="/my-docs"
                className={({ isActive }) =>
                  `glass-account-link inline-flex min-h-[40px] items-center rounded-md px-4 text-sm font-bold ${isActive
                    ? "text-[#0f8c5f]"
                    : "text-[#34465a]"
                  }`
                }
              >
                Workspace
              </NavLink>
              {/* {location.pathname !== '/chat' && (
                <NavLink
                  to="/chat"
                  title="WhatsApp Inbox"
                  className="inline-flex min-h-[40px] items-center justify-center rounded-full border border-[#dfe8ef] bg-white/70 h-10 w-10 transition-colors hover:border-[#25D366] hover:bg-[#e8faf0]"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="#25D366">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884" />
                  </svg>
                </NavLink>
              )} */}
              {canAccessWorkspace(userInfo) ? (
                <NavLink
                  to="/dashboard"
                  className={({ isActive }) =>
                    `glass-account-link inline-flex min-h-[40px] items-center rounded-md px-4 text-sm font-bold ${isActive
                      ? "text-[#0f8c5f]"
                      : "text-[#34465a]"
                    }`
                  }
                >
                  Admin Console
                </NavLink>
              ) : null}
              <div className="account-menu group relative">
                <button className="glass-user-button flex min-h-[40px] items-center gap-2 rounded-full border border-[#dfe8ef] bg-white/70 px-2 py-1">
                  <img
                    src={userInfo.userProfileImg || userIcon}
                    alt={userInfo?.name || "User"}
                    className="h-8 w-8 rounded-full object-cover"
                  />
                  <span className="max-w-[120px] truncate pr-2 text-sm font-semibold text-[#26384d]">
                    {userInfo?.name || "Account"}
                  </span>
                </button>
                <div className="glass-dropdown invisible absolute right-0 top-full w-[220px] rounded-lg border border-white/55 bg-white/85 p-2 opacity-0 shadow-xl transition group-hover:visible group-hover:opacity-100">
                  <div className="border-b border-[#edf2f7] px-3 py-2">
                    <p className="truncate text-sm font-bold text-[#18324d]">
                      {userInfo?.name || "DocLift User"}
                    </p>
                    <p className="truncate text-xs text-[#6c7a89]">
                      {userInfo?.email || "Signed in"}
                    </p>
                  </div>
                  <Link
                    to="/my-docs"
                    className="mt-2 block rounded-md px-3 py-2 text-sm font-semibold text-[#34465a] hover:bg-[#f3f7fb]"
                  >
                    My Docs
                  </Link>
                  <button
                    onClick={logout}
                    className="block w-full rounded-md px-3 py-2 text-left text-sm font-semibold text-[#b42318] hover:bg-[#fff1f0]"
                  >
                    Logout
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="glass-account-link inline-flex min-h-[40px] items-center rounded-md px-4 text-sm font-bold text-[#34465a]"
              >
                Login
              </Link>
              <Link
                to="/login"
                className="glass-start-button inline-flex min-h-[40px] items-center rounded-md bg-[#13a66f] px-5 text-sm font-bold text-white"
              >
                Get Started
              </Link>
            </>
          )}
        </div>

        {/* WhatsApp icon + hamburger for mobile */}
        <div className="flex items-center gap-2 lg:hidden">
          {/* {userInfo && location.pathname !== '/chat' && (
            <Link
              to="/chat"
              title="WhatsApp Inbox"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#dfe8ef] bg-white/70 transition-colors hover:border-[#25D366] hover:bg-[#e8faf0]"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="#25D366">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884" />
              </svg>
            </Link>
          )} */}
          <button
            type="button"
            className="glass-menu-button inline-flex h-10 w-10 items-center justify-center rounded-md border border-white/55 text-[#18324d]"
            aria-label="Toggle navigation menu"
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? (
              <span className="text-sm font-bold">Close</span>
            ) : (
              <span className="flex flex-col gap-1">
                <span className="block h-[2px] w-5 bg-current" />
                <span className="block h-[2px] w-5 bg-current" />
                <span className="block h-[2px] w-5 bg-current" />
              </span>
            )}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="glass-mobile-menu pointer-events-auto mx-4 mt-2 rounded-lg border border-white/55 bg-white/85 px-4 py-4 shadow-lg lg:hidden">
          <nav className="grid gap-1">
            {[...marketingLinks, ...resourceLinks].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="rounded-md px-3 py-3 text-sm font-bold text-[#34465a] hover:bg-[#f3f7fb]"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="mt-4 grid gap-2 border-t border-[#edf2f7] pt-4">
            {userInfo ? (
              <>
                <Link
                  to="/my-docs"
                  className="rounded-md bg-[#13a66f] px-3 py-3 text-center text-sm font-bold text-white"
                >
                  Open Workspace
                </Link>
                {canAccessWorkspace(user) ? (
                  <Link
                    to="/dashboard"
                    className="rounded-md border border-[#dfe8ef] px-3 py-3 text-center text-sm font-bold text-[#34465a]"
                  >
                    Admin Console
                  </Link>
                ) : null}
                <button
                  onClick={logout}
                  className="rounded-md border border-[#f5c2bd] px-3 py-3 text-sm font-bold text-[#b42318]"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="rounded-md border border-[#dfe8ef] px-3 py-3 text-center text-sm font-bold text-[#34465a]"
                >
                  Login
                </Link>
                <Link
                  to="/login"
                  className="rounded-md bg-[#13a66f] px-3 py-3 text-center text-sm font-bold text-white"
                >
                  Get Started
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
